import { useEffect } from "react";
import DashboardGauge from "../components/DashboardGauge";
import { useGetPermitInProgressAvgDurationMetric } from "../operations/queries/getPermitAvgDurationMetrics";
import { useAppContext } from "../hooks/useAppContext";
import { PermitMetricScopeInput } from "../operations/queries/getPermitsCountByStatesMetric";

interface Props {
  scope?: PermitMetricScopeInput;
}

const PermitInProgressAvgDurationContainer = (props: Props) => {
  const { currentOrganization, currentPermitRegister } = useAppContext();

  const { getPermitInProgressAvgDurationMetric, data } = useGetPermitInProgressAvgDurationMetric();

  useEffect(() => {
    if (currentOrganization) {
      const activeScope: PermitMetricScopeInput = props.scope || {
        organizationId: currentOrganization.id,
        registerIds: currentPermitRegister?.id ? [currentPermitRegister.id] : null,
      };

      getPermitInProgressAvgDurationMetric({
        variables: { query: { scope: activeScope } },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization, currentPermitRegister, props.scope]);

  if (!data) return null;

  return (
    <DashboardGauge
      header="Permit Preparation Efficiency"
      description="Average time in hours to submit a permit for issue on site"
      value={data.permitInProgressAvgDurationMetric.value > 0 ? data.permitInProgressAvgDurationMetric.value : null}
      maxValue={72}
    ></DashboardGauge>
  );
};

export default PermitInProgressAvgDurationContainer;
